const env = require('services/env')
const { queryObject } = require('helpers/object')

class Auth {
  /// //////////////////////////////
  // Getters
  /// //////////////////////////////

  get user () {
    return env.get('user')
  }

  get roles () {
    return env.get('roles')
  }

  get user_shop_id () {
    return this.user.primary_role.pivot.shop_id
  }

  get shop_id () {
    return this.user.primary_role.pivot.shop_id
  }

  get shop () {
    return this.user.shop
  }

  get user_role () {
    return this.user.primary_role.slug
  }

  get db_roles () {
    return env.get('role_records', this.roles);
  }

  get manageable_roles () {
    const role = this.roles[this.user_role]
    const manageable = queryObject(role, 'meta.manageable_roles', [])

    const manageable_roles = {}

    Object.keys(this.roles)
      .filter(role => manageable.includes(role))
      .forEach(role => {
        manageable_roles[role] = this.roles[role];
        manageable_roles[role].name = this.db_roles[role].name;
      });

    return manageable_roles
  }

  get impersonating () {
    return env.get('impersonating', false)
  }

  get canManageShops () {
    return this.user_shop_id === null
  }

  get hasOwnShop () {
    return this.user_shop_id !== null
  }

  get canPerformDeliveryRuleActions() {
    return !this.userHasRole('owner');
  }

  get displayNotifications () {
    if (!this.shop) return false

    return !!this.shop.show_notifications
  }

  get isBloomitVip () {
    if (!this.user.shop) return false

    const { is_bloomit_shop, is_vip } = this.user.shop

    return is_bloomit_shop && is_vip
  }

  /// //////////////////////////////
  // Helpers
  /// //////////////////////////////

  userHasRole (role) {
    return this.user_role === role
  }

  getOperations (resource) {
    const ops = env.get('operations.' + resource, {})

    return Object.keys(ops)
  }

  can (operation, resource, entry = null) {
    const ops = this.getOperations(resource)

    if (ops.length < 1) {
      return false
    }

    if (entry === null || !ops.includes(operation)) {
      return ops.includes(operation)
    }

    const permitted_actions = typeof entry.get === 'function'
      ? entry.get('permitted_actions')
      : entry.permitted_actions

    if (!permitted_actions || typeof (permitted_actions[operation]) === 'undefined') {
      return true
    }

    return permitted_actions[operation]
  }
}

module.exports = new Auth()
